import { UTCDate } from "@date-fns/utc";
import { formatRelative } from "date-fns";

export function formatUtcTimestamp(value: Date | string): string {
  return new Date(value).toLocaleString(undefined, {
    timeZone: "UTC",
    timeZoneName: "short",
  });
}

export function formatRelativeUtc(
  value: Date | string,
  baseDate = new Date(),
): string {
  return `${formatRelative(new UTCDate(new Date(value)), new UTCDate(baseDate))} UTC`;
}
